import React from "react";
import {
  NotificationCard as StyledNotificationCard,
  NotificationCardActions,
  NotificationCardContent,
  NotificationCardHeader,
} from "./notificationCard.styles";
import { OutlinedButton, PrimaryButton } from "../../../../../../shared/native/button.styles";
import { TitleH3 } from "../../../../../../shared/native/typography.styles";
import colors from "../../../../../../../core/styles/colors";

const NotificationCard: React.FC<{
  children?: React.ReactNode;
  title?: string;
  comment?: string;
  responseButtonText?: string;
  disableResponseButton?: boolean;
  hideResponseButton?: boolean;
  outlinedResponseButton?: boolean;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  onCancel?: () => void;
  handleSubmit: () => void;
}> = ({
  children,
  title,
  comment,
  responseButtonText,
  disableResponseButton,
  hideResponseButton,
  outlinedResponseButton,
  showCancelButton,
  cancelButtonText,
  onCancel,
  handleSubmit,
}) => {
  const ResponseButton = outlinedResponseButton ? OutlinedButton : PrimaryButton;

  return (
    <StyledNotificationCard onSubmit={handleSubmit}>
      <NotificationCardHeader>
        {!!title && <TitleH3 style={{ textAlign: "left" }}>{title}</TitleH3>}
        {!!comment && (
          <p style={{ marginTop: title ? 4 : 0 }}>
            <span>!</span>
            {comment}
          </p>
        )}
      </NotificationCardHeader>
      {!!children && <NotificationCardContent>{children}</NotificationCardContent>}
      <NotificationCardActions>
        {!hideResponseButton && (
          <ResponseButton
            type="submit"
            disabled={disableResponseButton || hideResponseButton}
            {...(outlinedResponseButton ? { initialBackground: colors.white.general } : undefined)}
          >
            {responseButtonText ?? "Ответить"}
          </ResponseButton>
        )}
        {showCancelButton && onCancel && (
          <PrimaryButton type="button" disabled={disableResponseButton} onClick={onCancel}>
            {cancelButtonText ?? "Отменить"}
          </PrimaryButton>
        )}
      </NotificationCardActions>
    </StyledNotificationCard>
  );
};

export default NotificationCard;
